module.exports = __webpack_public_path__ + "img/map-background.6c462dcb.png";